import { useEffect, useRef } from 'react';
import { Label, Text } from '../../../../../styles/component.styles';

const ContactFormUpdateSection = ({ onChange }) => {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!hasInitialized.current) {
      onChange({
        content: {},
        metadata: {
          padding: '2rem 0',
          margin: '2rem auto',
          background: 'transparent',
          align: 'center'
        }
      });
      hasInitialized.current = true;
    }
  }, [onChange]);

  return (
    <>
      <Label>Contact Form</Label>
      <Text>This section renders the default contact form. Styling is fixed in V1 and cannot be changed.</Text>
    </>
  );
};

export default ContactFormUpdateSection;